import { useState } from "react";

interface ConfirmationState {
  open: boolean;
  sectionId: number | null;
  sectionName: string;
}

export const useSectionDeselectConfirmation = () => {
  const [confirmationDialog, setConfirmationDialog] =
    useState<ConfirmationState>({
      open: false,
      sectionId: null,
      sectionName: "",
    });

  const showConfirmation = (sectionId: number, sectionName: string) => {
    setConfirmationDialog({
      open: true,
      sectionId,
      sectionName,
    });
  };

  const hideConfirmation = () => {
    setConfirmationDialog({
      open: false,
      sectionId: null,
      sectionName: "",
    });
  };

  const confirmDeselect = (onConfirm: (sectionId: number) => void) => {
    if (confirmationDialog.sectionId !== null) {
      onConfirm(confirmationDialog.sectionId);
    }
    hideConfirmation();
  };

  return {
    confirmationDialog,
    showConfirmation,
    hideConfirmation,
    confirmDeselect,
  };
};
